<mat-sidenav #sidenav mode="side" [(opened)]="opened" class="sidenav">
    <mat-nav-list>
      <mat-list-item>
        <button mat-button>Opción 1</button>
      </mat-list-item>
      <mat-list-item>
        <button mat-button>Opción 2</button>
      </mat-list-item>
      <mat-list-item>
        <button mat-button>Opción 3</button>
      </mat-list-item>
    </mat-nav-list>
  </mat-sidenav>